import { useMutation } from '@tanstack/react-query';
import acknowledgePlatformNumber from '@/API/PlatformNumber/acknowldgePlatformNumber';
import { toast } from 'react-toastify';

const useAcknowledgePlatformNumbers = (numbers, scope, refetch) => {
    return useMutation({
        mutationFn: async () => {
            try {
                const res = await Promise.all(
                    numbers.map(async (number) => {
                        return await acknowledgePlatformNumber(
                            number.numberID,
                            number.platformID,
                            scope,
                        );
                    }),
                );
                toast.success('Platform numbers acknowledged successfully!');
                refetch();
                return res;
            } catch (error) {
                throw new Error(
                    error?.message || 'Failed to update platform numbers',
                );
            }
        },
    });
};

export default useAcknowledgePlatformNumbers;
